import { Observable, ReplaySubject } from 'rxjs';
import { ChangeDetectorRef, Directive, inject } from '@angular/core';
import { CloudMatrixService } from './cloud-matrix.service';
import { CloudMatrixUtils } from './utils/cloud-matrix-utils';
import { AnywhereData } from './types/anywhere-api.type';
import { AnywhereFilters, AnywhereQueryParams } from './types/anywhere.type';
import { BaseComponentDirective } from '@streamamg/amg-common';

@Directive()
export class CloudMatrixDirective<AnywhereMetaData> extends BaseComponentDirective {
  /**
   * Flag true when the request is loading and false when the data are ready
   */
  public isLoading: boolean | undefined;

  /**
   * CloudMatrix base path
   * @required
   */
  public anywhereUrl: string | undefined;
  /**
   * List of CM items (VOD)
   */
  public anywhereData?: AnywhereData<AnywhereMetaData>;
  /**
   * Number of items to load
   */
  protected pageSize: number = 25;
  /**
   * CloudMatrix filters
   */
  protected filters?: AnywhereFilters;
  /**
   * Query parameters for the cloudMatrix ajax call
   */
  protected queryParams?: AnywhereQueryParams;
  /**
   * To disable the cache and execute a new ajax call everytime
   */
  protected noCache?: boolean;

  protected cd = inject(ChangeDetectorRef);
  protected cloudMatrixService = inject(CloudMatrixService<AnywhereMetaData>);

  constructor() {

    super();
  }

  /**
   * Get CM data passing filters
   */
  public getData(isLoadMore?: boolean, startPageIndex?: number): Observable<boolean> {
    this.isLoading = true;
    const replaySubject = new ReplaySubject<boolean>(1);

    if (this.anywhereUrl != null) {
      this.subSink = this.cloudMatrixService
          .triggerApiCall(this.anywhereUrl, this.pageSize, isLoadMore ? this.anywhereData : undefined, this.filters, this.noCache, this.queryParams, startPageIndex)
          .subscribe(anywhereData => {

            if (!anywhereData.loading) {

              if (anywhereData.error && this.anywhereData) {

                this.anywhereData.error = true;
              } else {

                this.anywhereData = anywhereData;
              }

              this.isLoading = false;
              this.cd.detectChanges();

              replaySubject.next(true);
              replaySubject.complete();
            }
          });
    }

    return replaySubject.asObservable();
  }


  /**
   * Check if more date are available
   */
  public isMoreDataAvailable(): boolean {
    return this.anywhereData?.pagingData ? CloudMatrixUtils.isMoreDataAvailable(this.anywhereData?.pagingData) : false;
  }

}
